module.exports = __webpack_public_path__ + "static/media/loader.f56eceb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/loader.svg
// module id = 64
// module chunks = 0